import React from "react";

import { ContentArea } from "components/ContentArea";

import { IChildrenProp } from "types/IChildrenProp";

interface IProps extends IChildrenProp {}

const MainContent = ({ children }: IProps) => {
  return (
    <ContentArea
      mt={6}
      mx={4}
      p={4}
      overflowY={{
        base: "hidden",
        lg: "auto",
      }}
      borderRadius={15}
      minH="700px"
    >
      {children}
    </ContentArea>
  );
};

export { MainContent };
